module.exports = __webpack_public_path__ + "img/nfts-blue.539e4f26.svg";